import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import SimpleBar from 'simplebar-react';
import type { BudgetStatement, MetricWithoutBudget } from '@/modules/finances/types';
import { BudgetStatementMobileItem } from './budget-statement-mobile-item';
import { useBudgetStatementList } from './use-budget-statement-list';
interface BudgetStatementListMobileProps {
  budgetStatements: BudgetStatement[];
  selectedMetric: MetricWithoutBudget;
  className?: string;
  asSectionContent?: boolean;
}
function BudgetStatementListMobile(t0) {
  const $ = _c(24);
  const {
    budgetStatements,
    selectedMetric,
    asSectionContent: t1,
    className
  } = t0;
  const asSectionContent = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== asSectionContent || $[1] !== budgetStatements) {
    t2 = {
      budgetStatements,
      asSectionContent
    };
    $[0] = asSectionContent;
    $[1] = budgetStatements;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    simpleBarRef,
    cardContentRef,
    itemsWrapperRef
  } = useBudgetStatementList(t2);
  const t3 = !asSectionContent && "-mx-2 px-2 pb-2";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("-mt-2 pt-2", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = asSectionContent && "px-2 pb-2";
  let t6;
  if ($[5] !== t5) {
    t6 = cn("flex w-full flex-col gap-2", t5);
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== budgetStatements || $[8] !== selectedMetric) {
    let t8;
    if ($[10] !== selectedMetric) {
      t8 = budgetStatement => <BudgetStatementMobileItem key={budgetStatement.id} budgetStatement={budgetStatement} selectedMetric={selectedMetric} />;
      $[10] = selectedMetric;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    t7 = budgetStatements.map(t8);
    $[7] = budgetStatements;
    $[8] = selectedMetric;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[12] !== itemsWrapperRef || $[13] !== t6 || $[14] !== t7) {
    t8 = <div ref={itemsWrapperRef} className={t6}>{t7}</div>;
    $[12] = itemsWrapperRef;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== simpleBarRef || $[17] !== t4 || $[18] !== t8) {
    t9 = <SimpleBar ref={simpleBarRef} className={t4} autoHide={false}>{t8}</SimpleBar>;
    $[16] = simpleBarRef;
    $[17] = t4;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== cardContentRef || $[21] !== className || $[22] !== t9) {
    t10 = <div ref={cardContentRef} className={className}>{t9}</div>;
    $[20] = cardContentRef;
    $[21] = className;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
export { BudgetStatementListMobile };